// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"a8451892","182":"e4c69e05","239":"7bc6ac2a","268":"b7ee10d3","455":"0d7ffd92","863":"3252a4df","977":"43ca0219"}[chunkId] + ".chunk.js";
};